/* istanbul ignore file */
export const validateResponseStatus = (response: Response) => {
  if (response?.status >= 500) {
    throw new Error('delivery failure');
  }
  if (response?.status >= 400) {
    throw new Error('collection not found');
  }
};
